import parse from "html-react-parser";
import reactStringReplace from "react-string-replace";
import {stripHTMLTags} from "../../utils/helpers";
import classes from "./LatexParser.module.css"
import {LATEX_REG_EXP} from "../../utils/constants";
import katex from "katex";
import DOMPurify from "dompurify";

import { __parse } from "katex"
import {Fragment} from "react";


const cleanMathHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(DOMPurify.sanitize(html), "text/html");

    doc.body.querySelectorAll("*").forEach((node) => {
        let nodeText = node.textContent.trim();
        if (/^\$latex\s([^$]+)\$$/.exec(nodeText)) {
            node.replaceWith(document.createTextNode(nodeText));
        }
    });

    return doc.body.innerHTML.trim();
}

export const cleanHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    return doc.body.textContent.trim();
}

export const LatexHTMLInline = ({children}) => {
    if (!children) {
        return <></>;
    }

    let text = cleanMathHTML(children);


    let replace = reactStringReplace(text, LATEX_REG_EXP, (exp, i) => {
        let elementStr = "";
        try {
            elementStr = katex.renderToString(stripHTMLTags(exp));
        } catch (e) {
            elementStr = stripHTMLTags(exp);
        }
        return elementStr;
    });

    return (
        <span className={classes.latexContainer}>
            {parse(replace.join(' '))}
        </span>
    );
}

export const LatexInline = ({children}) => {
    if (!children) {
        return <></>;
    }

    let text = cleanMathHTML(children);

    return (
        <span className={classes.latexInlineContainer}>
            {reactStringReplace(stripHTMLTags(text), LATEX_REG_EXP, (exp, i) => {
                let elementStr = "";
                try {
                    elementStr = katex.renderToString(exp);
                } catch (e) {
                    elementStr = exp;
                }
                return (
                    <Fragment key={i}> {parse(elementStr)}</Fragment>
                );
            })}
        </span>
    );

}

/**
 * Walk the KaTeX parse tree and convert math to plain text.
 */
function walk(node) {
    if (Array.isArray(node)) {
        return node.map(walk).join(' ');
    }

    if (!node || typeof node !== 'object') {
        return '';
    }

    switch (node.type) {
        case 'mathord':
        case 'textord':
            return node.text;

        case 'op':
            if (node.name === '\\int') return '∫';
            return node.name;

        case 'supsub': {
            const base = walk(node.base);
            const sup = node.sup ? walk(node.sup) : null;
            const sub = node.sub ? walk(node.sub) : null;

            if (sup && sub) return `${base}_${sub}^${sup}`;
            if (sup) return `${base}^${sup}`;
            if (sub) return `${base}_${sub}`;
            return base;
        }

        case 'ordgroup':
            return node.body.map(walk).join(' ');

        case 'sqrt':
            return `√(${walk(node.body)})`;

        case 'frac':
            return `(${walk(node.numer)})/(${walk(node.denom)})`;

        case 'atom':
            return walk(node.body);

        case 'bin':
        case 'rel':
        case 'punct':
            return node.text || '';

        default:
            return '';
    }
}


export const LatexToText = (children) => {
    if (!children) {
        return <></>;
    }

    let text = cleanMathHTML(children);
    return reactStringReplace(stripHTMLTags(text), LATEX_REG_EXP, (exp, i) => {
        let elementStr = "";
        try {
            const tree = __parse(exp);
            let res = walk(tree);
            elementStr = res.replace(/\s+/g, ' ').trim();
        } catch (e) {
            console.warn('Invalid LaTeX:', exp, e);
            elementStr = exp;
        }
        return parse(elementStr);
    });
}



export const convertToPlainString = (text) => {
    if (!text) {
        return "";
    }

    return reactStringReplace(cleanMathHTML(text), LATEX_REG_EXP, (exp, i) => {
        return exp;
    }).join('');
}

export const hasLatex = (text) => {
    if (!text) {
        return false;
    }

    return Boolean(text.match(LATEX_REG_EXP));
}